/**
 * @fileoverview gRPC-Web generated client stub for qowner.erp.api.v1.services
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.20.3
// source: projects/erp/service/api/v1/services/task_types.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

var projects_erp_service_api_v1_model_task_type_pb = require('./task_type_pb.js')
const proto = {};
proto.qowner = {};
proto.qowner.erp = {};
proto.qowner.erp.api = {};
proto.qowner.erp.api.v1 = {};
proto.qowner.erp.api.v1.services = require('./task_types_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.qowner.erp.api.v1.services.TaskTypesClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.qowner.erp.api.v1.services.TaskTypesPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.qowner.erp.api.v1.services.ListTaskTypesRequest,
 *   !proto.qowner.erp.api.v1.services.ListTaskTypesResponse>}
 */
const methodDescriptor_TaskTypes_ListTaskTypes = new grpc.web.MethodDescriptor(
  '/qowner.erp.api.v1.services.TaskTypes/ListTaskTypes',
  grpc.web.MethodType.UNARY,
  proto.qowner.erp.api.v1.services.ListTaskTypesRequest,
  proto.qowner.erp.api.v1.services.ListTaskTypesResponse,
  /**
   * @param {!proto.qowner.erp.api.v1.services.ListTaskTypesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.qowner.erp.api.v1.services.ListTaskTypesResponse.deserializeBinary
);


/**
 * @param {!proto.qowner.erp.api.v1.services.ListTaskTypesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.qowner.erp.api.v1.services.ListTaskTypesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.qowner.erp.api.v1.services.ListTaskTypesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.qowner.erp.api.v1.services.TaskTypesClient.prototype.listTaskTypes =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/qowner.erp.api.v1.services.TaskTypes/ListTaskTypes',
      request,
      metadata || {},
      methodDescriptor_TaskTypes_ListTaskTypes,
      callback);
};


/**
 * @param {!proto.qowner.erp.api.v1.services.ListTaskTypesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.qowner.erp.api.v1.services.ListTaskTypesResponse>}
 *     Promise that resolves to the response
 */
proto.qowner.erp.api.v1.services.TaskTypesPromiseClient.prototype.listTaskTypes =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/qowner.erp.api.v1.services.TaskTypes/ListTaskTypes',
      request,
      metadata || {},
      methodDescriptor_TaskTypes_ListTaskTypes);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.qowner.erp.api.v1.services.GetTaskTypeRequest,
 *   !proto.qowner.erp.api.v1.model.TaskType>}
 */
const methodDescriptor_TaskTypes_GetTaskType = new grpc.web.MethodDescriptor(
  '/qowner.erp.api.v1.services.TaskTypes/GetTaskType',
  grpc.web.MethodType.UNARY,
  proto.qowner.erp.api.v1.services.GetTaskTypeRequest,
  projects_erp_service_api_v1_model_task_type_pb.TaskType,
  /**
   * @param {!proto.qowner.erp.api.v1.services.GetTaskTypeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  projects_erp_service_api_v1_model_task_type_pb.TaskType.deserializeBinary
);


/**
 * @param {!proto.qowner.erp.api.v1.services.GetTaskTypeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.qowner.erp.api.v1.model.TaskType)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.qowner.erp.api.v1.model.TaskType>|undefined}
 *     The XHR Node Readable Stream
 */
proto.qowner.erp.api.v1.services.TaskTypesClient.prototype.getTaskType =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/qowner.erp.api.v1.services.TaskTypes/GetTaskType',
      request,
      metadata || {},
      methodDescriptor_TaskTypes_GetTaskType,
      callback);
};


/**
 * @param {!proto.qowner.erp.api.v1.services.GetTaskTypeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.qowner.erp.api.v1.model.TaskType>}
 *     Promise that resolves to the response
 */
proto.qowner.erp.api.v1.services.TaskTypesPromiseClient.prototype.getTaskType =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/qowner.erp.api.v1.services.TaskTypes/GetTaskType',
      request,
      metadata || {},
      methodDescriptor_TaskTypes_GetTaskType);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.qowner.erp.api.v1.services.ApplyTaskTypeRequest,
 *   !proto.qowner.erp.api.v1.model.TaskType>}
 */
const methodDescriptor_TaskTypes_ApplyTaskType = new grpc.web.MethodDescriptor(
  '/qowner.erp.api.v1.services.TaskTypes/ApplyTaskType',
  grpc.web.MethodType.UNARY,
  proto.qowner.erp.api.v1.services.ApplyTaskTypeRequest,
  projects_erp_service_api_v1_model_task_type_pb.TaskType,
  /**
   * @param {!proto.qowner.erp.api.v1.services.ApplyTaskTypeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  projects_erp_service_api_v1_model_task_type_pb.TaskType.deserializeBinary
);


/**
 * @param {!proto.qowner.erp.api.v1.services.ApplyTaskTypeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.qowner.erp.api.v1.model.TaskType)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.qowner.erp.api.v1.model.TaskType>|undefined}
 *     The XHR Node Readable Stream
 */
proto.qowner.erp.api.v1.services.TaskTypesClient.prototype.applyTaskType =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/qowner.erp.api.v1.services.TaskTypes/ApplyTaskType',
      request,
      metadata || {},
      methodDescriptor_TaskTypes_ApplyTaskType,
      callback);
};


/**
 * @param {!proto.qowner.erp.api.v1.services.ApplyTaskTypeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.qowner.erp.api.v1.model.TaskType>}
 *     Promise that resolves to the response
 */
proto.qowner.erp.api.v1.services.TaskTypesPromiseClient.prototype.applyTaskType =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/qowner.erp.api.v1.services.TaskTypes/ApplyTaskType',
      request,
      metadata || {},
      methodDescriptor_TaskTypes_ApplyTaskType);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.qowner.erp.api.v1.services.DeleteTaskTypeRequest,
 *   !proto.qowner.erp.api.v1.services.DeleteTaskTypeResponse>}
 */
const methodDescriptor_TaskTypes_DeleteTaskType = new grpc.web.MethodDescriptor(
  '/qowner.erp.api.v1.services.TaskTypes/DeleteTaskType',
  grpc.web.MethodType.UNARY,
  proto.qowner.erp.api.v1.services.DeleteTaskTypeRequest,
  proto.qowner.erp.api.v1.services.DeleteTaskTypeResponse,
  /**
   * @param {!proto.qowner.erp.api.v1.services.DeleteTaskTypeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.qowner.erp.api.v1.services.DeleteTaskTypeResponse.deserializeBinary
);


/**
 * @param {!proto.qowner.erp.api.v1.services.DeleteTaskTypeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.qowner.erp.api.v1.services.DeleteTaskTypeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.qowner.erp.api.v1.services.DeleteTaskTypeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.qowner.erp.api.v1.services.TaskTypesClient.prototype.deleteTaskType =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/qowner.erp.api.v1.services.TaskTypes/DeleteTaskType',
      request,
      metadata || {},
      methodDescriptor_TaskTypes_DeleteTaskType,
      callback);
};


/**
 * @param {!proto.qowner.erp.api.v1.services.DeleteTaskTypeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.qowner.erp.api.v1.services.DeleteTaskTypeResponse>}
 *     Promise that resolves to the response
 */
proto.qowner.erp.api.v1.services.TaskTypesPromiseClient.prototype.deleteTaskType =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/qowner.erp.api.v1.services.TaskTypes/DeleteTaskType',
      request,
      metadata || {},
      methodDescriptor_TaskTypes_DeleteTaskType);
};


module.exports = proto.qowner.erp.api.v1.services;

